"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function etn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M14.9093 10.1017L17.3385 7.54275C18.384 8.79099 18.9558 10.368 18.9533 11.9963C18.9533 15.834 15.8408 18.9457 12 18.9457C10.8282 18.9472 9.67521 18.6512 8.649 18.0855L14.8275 14.901L15.834 14.382L14.9018 13.7377L14.2358 13.2772L16.1783 12.2858L17.1443 11.7922L16.2788 11.1382L14.9093 10.1017ZM9.09075 14.2523L6.82575 16.6373C5.67856 15.3639 5.04465 13.7102 5.04675 11.9963C5.04675 8.15775 8.15925 5.046 12 5.046C13.3011 5.04424 14.5763 5.40919 15.6795 6.099L9.1725 9.453L8.166 9.97275L9.09825 10.6163L9.76425 11.0767L7.82175 12.069L6.85575 12.5618L7.72125 13.2165L9.09075 14.2523ZM6.402 17.085L5.93325 17.5785C4.52819 16.0593 3.74846 14.0656 3.75 11.9963C3.75 7.449 7.45125 3.75 12 3.75C13.8698 3.75 15.597 4.3755 16.9823 5.42775L16.3058 5.7765C15.0419 4.89799 13.5392 4.42788 12 4.4295C7.82625 4.4295 4.43025 7.824 4.43025 11.9963C4.43025 13.9537 5.17725 15.7395 6.40275 17.0842L6.402 17.085ZM17.763 7.095L18.234 6.6C19.5359 8.09612 20.252 10.013 20.25 11.9963C20.25 16.5427 16.5488 20.2418 12 20.2418C10.3238 20.2437 8.68713 19.7323 7.31025 18.7762L8.00325 18.4185C9.20172 19.1674 10.5868 19.5638 12 19.5623C16.1738 19.5623 19.5698 16.1677 19.5698 11.9963C19.5698 10.1287 18.8895 8.41725 17.763 7.09575V7.095ZM8.1315 12.675L11.0873 11.1652L9.4845 10.0583L18.357 5.48475L13.8923 10.1858L15.8685 11.6805L12.9128 13.1903L14.5155 14.2972L5.643 18.8707L10.1078 14.1698L8.1315 12.675Z", fill: color }));
}
exports["default"] = etn;
//# sourceMappingURL=etn.js.map